import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { App } from '@/app/App';
import { store } from '@/app/store';
import { initErrorReporter } from '@/shared/errorReporter';
import '@/styles/globals.css';

initErrorReporter();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);
